import { render, staticRenderFns } from "./ClientUserForm.vue?vue&type=template&id=2a89069c"
import script from "./ClientUserForm.vue?vue&type=script&lang=js"
export * from "./ClientUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports